import React, { FC } from 'react';
import classnames from 'classnames';
import { useTheme } from 'contexts/ThemeContext';
import PromotionBannerContainer from '../PromotionBanner';
import HeaderHamburger, { HeaderHamburgerProps } from '../HeaderHamburger';
import s from '../Header.module.scss';

const HeaderBase: FC<Props> = ({ logo, buttons, hamburger, banner, hasSingleButton, className }) => {
    const { theme } = useTheme();
    return (
        <>
            <header className={classnames(s[theme], s.root, s.headerBlock, className)}>
                <PromotionBannerContainer {...banner} />
                <div className={s.headerInner}>
                    <div className={s.headerWrapper}>
                        {hamburger && <HeaderHamburger {...hamburger} />}
                        {logo}
                        {buttons && (
                            <div className={hasSingleButton ? s.headerSingleButton : s.headerButtons}>{buttons}</div>
                        )}
                    </div>
                </div>
            </header>
            <div className={`${s[theme]} ${s.root} ${banner.margin}`} />
        </>
    );
};

interface Props {
    logo: React.ReactNode;
    buttons?: React.ReactNode;
    hamburger?: HeaderHamburgerProps;
    banner: {
        link?: string;
        isVisible?: boolean;
        close: () => void;
        margin: string;
    };
    hasSingleButton?: boolean;
    className?: string;
}

export default HeaderBase;
